import React, { useEffect, useState } from 'react'
import CustomHeader from '../Components/CustomHeader/CustomHeader'
import CustomCards from '../Components/CustomCards/CustomCards'
import CustomTable from '../Components/CustomTable/CustomTable'
import CustomPagination from '../Components/CustomPagination/CustomPagination'
import AuthNavbar from '../Components/AuthNavbar/AuthNavbar'
import { Badge, Container } from 'react-bootstrap'
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

import { useDispatch, useSelector } from 'react-redux'
import { deleteStudent, fetchStudent, fetchStudents } from '../hooks/students'
import { useNavigate } from 'react-router-dom'
import CustomModal from '../Components/CustomModal/CustomModal'

function Students() {
  const dispatch = useDispatch();
  const navigate = useNavigate()
  const { list, pagination } = useSelector((state) => state.students);
  const [page, setPage] = useState(1)
  console.log(pagination?.last_page);

  const downloadExcel = () => {
    if (!list || list.length === 0) return;

    const data = list.map((item) => ({
      "المستفيد": item?.name,
      "اسم المستخدم": item?.username,
      "الرقم العسكري": item?.military_number,
      "اسم المطعم": item?.restaurant?.name,
    }));

    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(workbook, worksheet, "Students");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const fileData = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    saveAs(fileData, "students.xlsx");
  };
  const [deleteShowModal, setDeleteShowModal] = useState(false);
  const [itemID, setItemID] = useState(true);
  const deleteItem = () => {
    dispatch(deleteStudent(itemID))
      .unwrap() // Allows us to use .then() / .catch() on the thunk result
      .then(() => {
        alert(`تم المسح المستفيد بنجاح`);
            dispatch(fetchStudents({ page }))

        setDeleteShowModal(false)

      })
      .catch((err) => {
        // Error is already handled in Redux, but you can do specific UI logic here
        console.error("Failed to save:", err);
      });

  }
  useEffect(() => {
    dispatch(fetchStudents({ page }))
  }, [dispatch, page])
  const header = [
    "المستفيد",
    "اسم المستخدم",
    "الرقم العسكري",
    "اسم المطعم",
    "",
    ""

  ]

  const body = <tbody>
    {list?.map((item, index) => {

      return (
    <tr>
      <td>{index+1}</td>
      <td>{item?.name}</td>
      <td>{item?.username}</td>
      <td>{item?.military_number}</td>
      <td>{item?.restaurant?.name}</td>
      <td><Badge bg="danger"onClick={()=>{             
        setDeleteShowModal(true)
                setItemID(item?.id)
} }>مسح</Badge></td>
      <td><Badge onClick={()=>navigate(`/dashboard/edit-student/${item?.id}`)} bg='primary'>تعديل</Badge></td>
    </tr>
    

      )
})}
  </tbody >
  return (
  <div>
                    <CustomModal show={deleteShowModal} onHide={() => setDeleteShowModal(false)}status={"student"}ar_status={"المستفيد"} deleteItem={deleteItem}/>

    <AuthNavbar />
    <Container>
      <CustomHeader
        title={"الالتحاق بالأكاديمية"}
        subtitle={"إدارة 1248 مستفيدًا نشطًا في برامج فنون الطهي"}
        downloadData={true}
        addData={true}
        status={"student"}
        downloadFunction={downloadExcel}



      />
      {/* <CustomCards
          data={data}
        /> */}
      <CustomTable
        data={list}
        fiteration={[]}
        currentData={25}
        allData={' 1,248  مستفيد'}
        header={header}
        status={"student"}
        body={body}

      />
      <CustomPagination


        currentPage={page}
        totalPages={pagination?.last_page}
        setCurrentPage={setPage}

      />
    </Container>
  </div>
)
}

export default Students